import { useTranslation } from "react-i18next";
import { SUPPORTED_LOCALES, type Locale } from "@/i18n";
import { Select } from "@/components/ui/select";

export function LocaleSwitcher(): React.ReactElement {
  const { t, i18n } = useTranslation();
  const current = (i18n.resolvedLanguage ?? "ru") as Locale;

  return (
    <label className="flex items-center gap-2 text-sm" data-testid="locale-switcher">
      <span className="text-muted-foreground">{t("locale.label")}</span>
      <Select
        className="w-auto"
        value={current}
        onChange={(value) => void i18n.changeLanguage(value)}
        placeholder={t("locale.label")}
        options={SUPPORTED_LOCALES.map((lng) => ({
          value: lng,
          label: t(`locale.${lng}` as const),
        }))}
        data-testid="locale-select"
      />
    </label>
  );
}
